<template>
  <div class="privacy-policy-page">
    <section class="hero-slab">
      <div class="hero-slab__media" :style="{ backgroundImage: 'url(' + site.hero.background + ')' }"></div>
      <div class="hero-slab__overlay"></div>
      <div class="hero-slab__content container reveal">
        <div class="section-title">
          <p>STRONGOVA</p>
          <h1>{{ title }}</h1>
        </div>
        <!-- <p>{{ $t('privacyPolicy.intro') }}</p> -->
      </div>
    </section>

    <page-trail
      :items="[
        { label: $t('common.home'), to: '/' },
        { label: title, to: '/privacy-policy' }
      ]"
      :back-label="$t('common.backToHome')"
      back-to="/"
    />

    <section class="section-spacing light-panel">
      <div class="container container-narrow reveal">
        <div class="privacy-policy-copy">
          <p v-for="(paragraph, index) in paragraphs" :key="'privacy-' + index">
            {{ paragraph }}
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import site from '../mock/strongova'
import PageTrail from '../components/PageTrail.vue'

export default {
  name: 'PrivacyPolicyPage',
  components: {
    PageTrail
  },
  data () {
    return {
      site
    }
  },
  computed: {
    settings () {
      return this.site.siteSettings || {}
    },
    title () {
      return this.settings.privacyPolicyTitle || this.$t('privacyPolicy.title')
    },
    content () {
      return this.settings.privacyPolicyContent || this.$t('privacyPolicy.defaultContent')
    },
    paragraphs () {
      return String(this.content || '')
        .split(/\n{2,}/)
        .map(item => item.trim())
        .filter(Boolean)
    }
  }
}
</script>

<style>
.privacy-policy-copy {
  margin: 0 auto;
  color: rgba(23, 20, 17, 0.74);
  font-size: 17px;
  line-height: 1.9;
}

.privacy-policy-copy p {
  margin: 0 0 22px;
}

.privacy-policy-copy p:last-child {
  margin-bottom: 0;
}

@media (max-width: 640px) {
  .privacy-policy-copy {
    font-size: 15px;
    line-height: 1.8;
  }
}
</style>
